import React from 'react';

// Enhanced regex to catch more link formats including www. links
export const linkRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|]|\bwww\.[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;

/**
 * Checks if a string contains any links
 */
export const hasLinks = (text: string): boolean => {
  return linkRegex.test(text);
};

/**
 * Extracts all links from a text string
 */
export const extractLinks = (text: string): string[] => {
  const matches = text.match(linkRegex);
  return matches || [];
};

/**
 * Validates if a URL is properly formatted
 */
export const isValidUrl = (url: string): boolean => {
  try {
    // Ensure www. links have http:// prefix for validation
    const urlToTest = url.startsWith('www.') ? `http://${url}` : url;
    new URL(urlToTest);
    return true;
  } catch {
    return false;
  }
};

/**
 * Normalizes a URL (adds http:// prefix to www. links)
 */
export const normalizeUrl = (url: string): string => {
  return url.startsWith('www.') ? `http://${url}` : url;
};

/**
 * Counts the number of links in a text string
 */
export const countLinks = (text: string): number => {
  const matches = text.match(linkRegex);
  return matches ? matches.length : 0;
};

/**
 * Replaces links in text with clickable HTML (for preview purposes)
 */
export const renderLinksInText = (text: string): (string | React.ReactElement)[] => {
  const parts = text.split(linkRegex);
  
  return parts.filter(part => part).map((part, index) => {
    if (linkRegex.test(part)) {
      const href = normalizeUrl(part);
      return React.createElement('a', {
        key: index,
        href: href,
        target: '_blank',
        rel: 'noopener noreferrer',
        className: 'text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200',
        onClick: (e: React.MouseEvent) => e.stopPropagation()
      }, part);
    }
    return part;
  });
}; 